import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";
import { PayrollWCBWSIBEarningsSetup } from "../../components/PayrollWCBWSIBEarningsSetup";

export const PayrollWCBWSIBEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll WCB/WSIB Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll WCB/ WSIB Earnings", navigateTo: "/company/payrollWCBWSIBEarnings/setup" }
      ]}
      mainContents={<PayrollWCBWSIBEarningsSetup />}
    />
  );
};
